// extracted by mini-css-extract-plugin
module.exports = {"component":"accent_component__CGvaO","accent":"accent_accent__LVnn7","textWrapper":"accent_textWrapper__RWElq","text":"accent_text__HuAFo"};